import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  Container,
  Divider,
  Center,
  Button,
  Text,
  Image,
  Stack,
  Input,
  InputGroup,
  InputLeftAddon,
  Heading,
  VStack,
  RadioGroup,
  Radio,
  Select,
  HStack,
  SimpleGrid,
  Grid,
  GridItem,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { CSVLink, CSVDownload } from "react-csv";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../../ColorModeSwitcher";
import { Nav } from "../../containers/Nav";
import { getBrandReports } from "../../actions/brands";
import { validateUserAuth } from "../../helpers";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip);

function Reporting(props) {
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams("campaign");
  const campaign = searchParams.get("campaign");

  const [reports, setReports] = useState([]);
  const [currentReport, setCurrentReport] = useState(campaign || 0);
  const [reportsCsvData, setReportsCsvData] = useState([]);

  useEffect(() => {
    const userInfo = validateUserAuth();
    const brand = userInfo.organization;
    if (!brand) {
      navigate("/home");
    }
    let csvData = [
      /*["firstname", "lastname", "email"],
    ["Ahmed", "Tomi", "ah@smthing.co.com"],
    ["Raed", "Labes", "rl@smthing.co.com"],
    ["Yezzi", "Min l3b", "ymin@cocococo.com"],*/
    ];

    getBrandReports(userInfo.organization).then((r) => {
      const response = r.filter((re) => re.brand === userInfo.organization);
      setReports(response);

      if (campaign) {
        response.map((r, idx) => {
          if (r.campaign == campaign) {
            setCurrentReport(idx);
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    //Generate CSV data
    let csvReport = [];
    let rows = [];
    if (!reports.length) {
      return;
    }
    Object.keys(reports[currentReport].stats).map((s) => {
      switch (s) {
        case "messageTagline":
          csvReport.push(["Message Tagline", "Votes"]);
          break;
        case "themeLink":
          csvReport.push(["Art/Themes", "Votes"]);
          break;
        case "castLink":
          csvReport.push(["Cast", "Votes"]);
          break;
        case "influencerLink":
          csvReport.push(["Influencers", "Votes"]);
          break;
        case "socialLink":
          csvReport.push(["Culture", "Votes"]);
          break;
      }
      for (const r in reports[currentReport].stats[s]) {
        const key = r.includes("file")
          ? "https://hubitprototype.herokuapp.com" + r
          : r;
        csvReport.push([key, reports[currentReport].stats[s][r]]);
      }
      csvReport.push([]);
    });

    setReportsCsvData(csvReport);
  }, [currentReport, reports]);

  function getCurrentDate() {
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const year = now.getFullYear().toString().slice(-2);

    return `${month}${day}${year}`;
  }

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      h="200px"
      color="blackAlpha.700"
    >
      <Nav />

      <GridItem my="md" pl="2" area={"main"}>
        <Center>
          <VStack>
            <Heading mt="3" size="lg">
              Campaign Reports
            </Heading>
            <Box>
              <Select
                value={currentReport}
                onChange={(e) => {
                  navigate(
                    `/brandCampaigns/reports?campaign=${e.target.value}`
                  );
                  setCurrentReport(e.target.value);
                }}
              >
                {reports.map((r, idx) => {
                  return (
                    <option key={`campaign-option-${idx}`} value={idx}>
                      {r.campaign}
                    </option>
                  );
                })}
              </Select>
            </Box>
            {reports[currentReport] &&
              [reports[currentReport]].map((r, idx) => {
                const cards = Object.keys(r.stats);
                return (
                  <Box key={`box-${idx}-${r.campaign}`} mx="10" mb="25px">
                    <Divider my="4" />
                    <Heading ml="10">{r.campaign}</Heading>
                    <SimpleGrid columns={3} spacing={10}>
                      {cards.map((card, cdx) => {
                        const options = Object.keys(r.stats[card]) || [];

                        let label = "";
                        switch (card) {
                          case "messageTagline":
                          case "messageTaglines":
                            label = "Message Tagline";
                            break;
                          case "themeLink":
                          case "themeLinks":
                          case "themeImages":
                            label = "Art/Themes";
                            break;
                          case "influencerLink":
                          case "influencerLinks":
                            label = "Influencers";
                            break;
                          case "socialLink":
                          case "socialLinks":
                          case "socialImages":
                            label = "Culture";
                            break;
                          case "castLink":
                          case "castLinks":
                          case "castImages":
                            label = "Cast";
                            break;
                          default:
                            label = card;
                            break;
                        }

                        const data = {
                          labels: options.map((opt, idx) => {
                            return opt.includes("api") ? idx + 1 : opt;
                          }),
                          datasets: [
                            {
                              data: options.map((opt) => r.stats[card][opt]),
                              borderColor: "rgb(255, 99, 132)",
                              backgroundColor: [
                                "rgba(255, 99, 132, 0.5)",
                                "rgba(55, 162, 235, 0.5)",
                                "rgba(255, 99, 132, 0.5)",
                                "rgba(55, 162, 235, 0.5)",
                                "rgba(255, 99, 132, 0.5)",
                                "rgba(55, 162, 235, 0.5)",
                              ],
                            },
                          ],
                        };

                        return (
                          <Box key={`card-${idx}-${cdx}`} width="100%">
                            <Card width="100%" p="3" height="100%">
                              <Heading size="sm" m="2">
                                {label}
                              </Heading>
                              <Bar options={{ indexAxis: "y" }} data={data} />
                              <HStack>
                                {options.map((opt, idx) =>
                                  opt.includes("api") ? (
                                    <Box key={`options-${idx}-box`}>
                                      <Box>
                                        <Text as="b">{idx + 1}</Text>
                                      </Box>
                                      <Box>
                                        <Image
                                          boxSize="70px"
                                          src={
                                            "https://hubitprototype.herokuapp.com" +
                                            opt
                                          }
                                        />
                                      </Box>
                                    </Box>
                                  ) : (
                                    <></>
                                  )
                                )}
                              </HStack>
                            </Card>
                          </Box>
                        );
                      })}
                    </SimpleGrid>
                  </Box>
                );
              })}
            {reportsCsvData.length > 0 && reports[campaign] && (
              <CSVLink
                filename={`${
                  reports[campaign].campaign
                }-${getCurrentDate()}-reports.csv`}
                data={reportsCsvData}
              >
                <Button>Download {reports[campaign]?.campaign} as .csv</Button>
              </CSVLink>
            )}
          </VStack>
        </Center>
      </GridItem>
    </Grid>
  );
}

export default Reporting;
